export default __webpack_public_path__ + "static/media/eye-open-2.5388b179.svg";